export default {"src":"/_next/static/media/equals_regular.f04b2a49.svg","height":24,"width":24};